const strategyActions = ['fold', 'call', 'check', 'bet', 'raise', 'small', 'big'];

// Use the whole-range strategy, never an individual hand's recommended action.
export const isForcedPostflopStrategy = (strategy = {}) => {
  const weights = strategyActions.map((action) => Number(strategy[action] ?? 0));
  return weights.every((weight) => Number.isFinite(weight) && weight >= 0)
    && weights.filter((weight) => weight > 0).length === 1
    && weights.includes(100);
};

// Challenge chooses a board after Start. These HU opening pools are entirely
// check-only in the solver data, so they can be disabled before dealing a hand.
export const isForcedPostflopChallenge = ({
  tableSize, stackSize, positionType, currentStep, boardType, handType, isPlo5,
}) => (
  tableSize === 'HU' && positionType === 'SRP'
  && currentStep.length === 1 && currentStep[0] === 'starting'
  && (stackSize === '100bb'
    || (!isPlo5 && stackSize === '50bb'
      && (boardType === 'paired' || handType === 'flush')))
);
